import Administration from "../../../components/Administration/Administration";

const AdministrationPage = () => {
    return (
        <Administration></Administration>
    );
}

export default AdministrationPage;
